<template>
  <svg
    :class="size"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.88 15.9998L26.28 7.61309C26.5311 7.36202 26.6721 7.02149 26.6721 6.66643C26.6721 6.31136 26.5311 5.97083 26.28 5.71976C26.0289 5.46869 25.6884 5.32764 25.3334 5.32764C24.9783 5.32764 24.6378 5.46869 24.3867 5.71976L16 14.1198L7.61335 5.71976C7.36228 5.46869 7.02176 5.32764 6.66669 5.32764C6.31162 5.32764 5.97109 5.46869 5.72002 5.71976C5.46895 5.97083 5.3279 6.31136 5.3279 6.66643C5.3279 7.02149 5.46895 7.36202 5.72002 7.61309L14.12 15.9998L5.72002 24.3864C5.59505 24.5104 5.49586 24.6578 5.42817 24.8203C5.36047 24.9828 5.32562 25.1571 5.32562 25.3331C5.32562 25.5091 5.36047 25.6834 5.42817 25.8459C5.49586 26.0083 5.59505 26.1558 5.72002 26.2798C5.84397 26.4047 5.99144 26.5039 6.15392 26.5716C6.3164 26.6393 6.49067 26.6742 6.66669 26.6742C6.8427 26.6742 7.01698 26.6393 7.17946 26.5716C7.34193 26.5039 7.4894 26.4047 7.61335 26.2798L16 17.8798L24.3867 26.2798C24.5106 26.4047 24.6581 26.5039 24.8206 26.5716C24.9831 26.6393 25.1573 26.6742 25.3334 26.6742C25.5094 26.6742 25.6836 26.6393 25.8461 26.5716C26.0086 26.5039 26.1561 26.4047 26.28 26.2798C26.405 26.1558 26.5042 26.0083 26.5719 25.8459C26.6396 25.6834 26.6744 25.5091 26.6744 25.3331C26.6744 25.1571 26.6396 24.9828 26.5719 24.8203C26.5042 24.6578 26.405 24.5104 26.28 24.3864L17.88 15.9998Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'h-8 w-8'
    },
    fill: {
      type: String,
      default: () => '#171717'
    }
  }
}
</script>
